import React from "react";

import { LanguageContextType } from "types";

const LanguageContext = React.createContext({} as LanguageContextType);

export default LanguageContext;
